<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="_idContainer002">
<p class="pl-title"><a id="_idTextAnchor000"></a>Peril on the Mountain</p>
<p class="pl-author">Elizabeth Goddard</p>
<p class="pl-center"><b>Previously published as <i>Buried</i> and <i>Untraceable</i></b></p>
<p class="pl-logo"><img alt="logo" height="70" src="image/LI_2020.png"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title_Page.vue?38066bb4